<ul class="hamburger-menu">
    <li app-menuitem *ngFor="let item of model" [item]="item"></li>
</ul>